import { Button } from "@/components/ui/button";
import { resetPasswordTokenSchema } from "@backend/src/schemas/authSchema";
import { isAxiosError } from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import { toFormikValidationSchema } from "zod-formik-adapter";
import ErrorMessage from "@/components/common/ErrorMessage";
import PasswordReset from "../../../assets/svg/PasswordReset.svg";
import { z } from "zod";
import useResetPasswordMutation from "@/api/mutation/useResetPasswordMutation";
import InputPassword from "@/components/common/inputPassword";
import { toast } from "react-toastify";
import BackgroundImage from "@/components/layout/BackgroundImage";
import NewLogoTitle from "@/assets/svg/NewLogoTitle.svg";
import { errorConfig } from "@/lib/toastError";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { useTranslation } from "react-i18next";
function ResetPassword() {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const resetPasswordMutation = useResetPasswordMutation(
    searchParams.get("token") ?? ""
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmited] = useState(false);
  const [iserror, setIsError] = useState("");
  const labelStyle = "font-medium text-base text-gray-8 ";
  const inputStyle =
    "py-1.5 px-3 rounded-md border border-gray-100 w-full h-[46px] focus:outline-primary-400";
  const navigate = useNavigate();
  const formik = useFormik<z.infer<typeof resetPasswordTokenSchema>>({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: toFormikValidationSchema(resetPasswordTokenSchema),
    onSubmit: (values, helper) => {
      setIsLoading(true);
      resetPasswordMutation.mutate(values, {
        onSuccess(data) {
          setIsLoading(false);
          setIsSubmited(true);
          toast.success(data.data.message);
        },
        onError(error) {
          if (isAxiosError(error)) {
            setIsLoading(false);
            setIsError(error.response?.data.message ?? "");
            if (
              error.response?.status === 400 &&
              error.response.data?.errors &&
              Array.isArray(error.response?.data.errors)
            ) {
              error.response.data.errors.forEach((item) => {
                helper.setFieldError(item.path[0], item.message);
              });
            }
            if (!Array.isArray(error.response?.data.errors)) {
              toast.error(
                errorKeyFormate(error.response?.data.message + ""),
                errorConfig
              );
            }
          }
        },
      });
    },
  });
  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      navigate("/login");
    }
  }, []);

  return (
    <div className="flex flex-col px-2 items-center min-h-screen py-6 justify-center bg-secondary-950">
      <BackgroundImage />
      <div className="absolute bg-primary-500/20 rounded-br-3xl px-40 rounded-bl-3xl mb-5 h-24 w-auto top-0  left-1/2 -translate-x-1/2 flex justify-center items-center">
        <img src={NewLogoTitle} className="h-10" />
      </div>
      <div className="w-[min(400px,100%)] space-y-4 py-4 overflow-hidden bg-white shadow-md sm:max-w-lg sm:rounded-lg">
        <div className="px-4">
          <h3 className="text-2xl text-center font-bold text-primary-900">
            {!isSubmitted ? t("Reset Password") : ""}
          </h3>
        </div>
        <hr />
        {isSubmitted ? (
          <div className="flex flex-col justify-center items-center">
            <div className="h-16 w-16 rounded-full bg-success bg-opacity-60 flex justify-center items-center">
              <img src={PasswordReset} alt="" width={50} />
            </div>
            <div className="text-center mt-3">
              <p>
                {t("Password Reset Successful!")}
                <br /> {t("Kindly proceed to log in.")}
              </p>
            </div>
            <div className="w-full p-3 mt-3">
              <Button
                type="submit"
                variant={"primary"}
                className="w-full"
                onClick={() => navigate("/login")}
              >
                {t("Login")}
              </Button>
            </div>
          </div>
        ) : (
          <form onSubmit={formik.handleSubmit} className="px-4 flex flex-col">
            <div className="w-full mt-1">
              <label htmlFor="password" className={labelStyle}>
                {t("New Password")}
              </label>
              <div className="relative mt-1">
                <InputPassword
                  name="password"
                  className={inputStyle}
                  placeholder="Enter password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                />
              </div>
              <div>
                <ErrorMessage>
                  {formik.touched.password && formik.errors.password}
                </ErrorMessage>
              </div>
            </div>
            <div className="mt-1">
              <label htmlFor="showConfirmationPassword" className={labelStyle}>
                {t("Confirm New Password")}
              </label>
              <div className="relative mt-1">
                <InputPassword
                  name="confirmPassword"
                  className={inputStyle}
                  placeholder="Enter password again"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                />
              </div>
              <div>
                <ErrorMessage>
                  {formik.touched.confirmPassword &&
                    formik.errors.confirmPassword}
                </ErrorMessage>
              </div>
            </div>
            {iserror && <ErrorMessage>{iserror}</ErrorMessage>}
            <div className="w-full flex justify-end items-center my-3">
              <NavLink className="font-bold underline text-xs" to="/login">
                {t("Login here")}
              </NavLink>
            </div>
            <div className="flex flex-col justify-center mt-1.5">
              <Button
                type="submit"
                variant={"primary"}
                className="w-full"
                isLoading={isLoading}
                disabled={isLoading}
              >
                {t("submit")}
              </Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
